// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-Layout-styles___layout--nR4vx {
  display: flex;
}

.components-Layout-styles___content--NlWlu {
  flex: 1 0 0;
  padding: 40px 16px;
  max-width: 1200px;
  margin: auto;
}

.components-Layout-styles___content--NlWlu.components-Layout-styles___full--Kl55X {
    padding: 0;
    max-width: 100%;
  }

@media only screen and (min-width: 1024px) {

.components-Layout-styles___content--NlWlu {
    padding: 40px 32px
}
  }

@media only screen and (min-width: 1440px) {

.components-Layout-styles___content--NlWlu {
    padding: 40px
}
  }
`, "",{"version":3,"sources":["webpack://./components/Layout/styles.pcss"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AAcd;;AAZE;IACE,UAAU;IACV,eAAe;EACjB;;AAEA;;AAXF;IAYI;AAMJ;EALE;;AAEA;;AAfF;IAgBI;AAEJ;EADE","sourcesContent":[".layout {\n  display: flex;\n}\n\n.content {\n  flex: 1 0 0;\n  padding: 40px 16px;\n  max-width: 1200px;\n  margin: auto;\n\n  &.full {\n    padding: 0;\n    max-width: 100%;\n  }\n\n  @media only screen and (min-width: 1024px) {\n    padding: 40px 32px;\n  }\n\n  @media only screen and (min-width: 1440px) {\n    padding: 40px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"layout": `components-Layout-styles___layout--nR4vx`,
	"content": `components-Layout-styles___content--NlWlu`,
	"full": `components-Layout-styles___full--Kl55X`
};
module.exports = ___CSS_LOADER_EXPORT___;
